/* eslint-disable sort-keys */

const radii = {
  small: '8px', // Chips, badges, small controls
  medium: '12px', // Inputs, buttons, menu items, media
  large: '16px', // Cards and panels
  pill: '999px', // Fully rounded controls
};

export default radii;
